import type { ReactNode } from "react";
import type { CurrentCommunity } from "@/react/types/CurrentCommunity";
import { useSetLocaleCookieFromParams } from "@circle-react/hooks/useSetLocaleCookieFromParams";
import { useStoreUtmParams } from "@circle-react/hooks/useStoreUtmParams";
import { PoweredByCircle } from "@circle-react-shared/PoweredByCircle";
import { CommunityImage } from "../../OnboardingComponents/CommunityImage";
import "./styles.css";

export interface NewCommunityAuthLayoutProps {
  children: ReactNode;
  currentCommunity?: CurrentCommunity;
  subtitle?: ReactNode;
  title: ReactNode;
}

export const NewCommunityAuthLayout = ({
  children,
  currentCommunity,
  subtitle,
  title,
}: NewCommunityAuthLayoutProps) => {
  useSetLocaleCookieFromParams();
  useStoreUtmParams();

  return (
    <div className="min-h-screen w-full bg-white">
      <div className="text-dark flex min-h-screen w-full min-w-full justify-center md:items-center">
        <div className="my-10 w-full max-w-[520px]">
          <div className="m-auto flex w-full flex-col items-center bg-white p-6 py-0 md:rounded-2xl md:p-12 md:py-10">
            <CommunityImage
              community={currentCommunity}
              withCircleBranding={!currentCommunity}
            />
            <h1 className="mt-4 text-center text-xl font-bold md:mt-6 md:text-2xl">
              {title}
            </h1>
            {subtitle && (
              <p className="text-light mt-1 text-center text-sm">{subtitle}</p>
            )}
            <div className="mt-10 w-full">{children}</div>
          </div>
          <div className="md:mt-2">
            <PoweredByCircle className="justify-center" />
          </div>
        </div>
      </div>
    </div>
  );
};
